import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import SupportRequests from '../../common/SupportRequests';

/** /support-requests: «Обращения» (admins and the group «Техподдержка», like /account-log). */
export default class SupportRequestsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    if (!app.forum.attribute('ppk2CanViewAccountLog')) {
      m.route.set(app.route('index'));
      return;
    }
    app.setTitle(app.translator.trans('ppk2-profile.lib.support.title'));
  }
  view() {
    if (!app.forum.attribute('ppk2CanViewAccountLog')) return m("div", null);
    return m("div", {
      className: "Ppk2AccountLogPage Ppk2SupportRequestsPage"
    }, m("div", {
      className: "container"
    }, m("h2", null, app.translator.trans('ppk2-profile.lib.support.title')), m(SupportRequests, null)));
  }
}
flarum.reg.add('ppk2-profile', 'forum/components/SupportRequestsPage', SupportRequestsPage);